import TokenService from "service/Token";

export const useAuth = () => {
  return !!TokenService.getIsAuthenticated();
};
